"use strict";

import {on, findIn, findAllIn, trigger, addClass} from "@elements/dom-utils";
import {onFind} from "@elements/init-modules-in-scope";
import {translate} from '@elements/translations';
import * as formValidation from '@elements/form-validation';
import {scrollTop} from "./ajax-form-extend";



export function init () {
    onFind('.js-validate-password', function (baseElement) {
        let isValid = false;
        let isSame = false;
        let hasValue = false;
        let form = findIn(".js-validate-password-form",baseElement);
        const password = findIn(".js-validate-password__input", baseElement);
        const repeatPassword = findIn(".js-validate-password-repeat__input", baseElement);
        const requirements = findAllIn(".js-validate-password__requirements", baseElement);
        const validatePasswordBtn = findIn(".js-validate-password__btn", baseElement);
        const validatePasswordSubmitBtn = findIn(".js-validate-password__btn-submit", baseElement);


        let lengBoolean,  smallLetterBoolean, numBoolean;
        let leng = findIn(".js-validate-password__leng",baseElement);
        let smallLetter = findIn(".js-validate-password__small-letter", baseElement);
        let num = findIn(".js-validate-password__num", baseElement);
        let errors = findIn(".js-form-errors", baseElement);
        const numbers = "0123456789";

        let submitButton = findIn('.js-validate-password__submit', form);
        if(submitButton){
            on('form-validation.submit' , (evt) => {
                validatePassword(evt, true);
            }, form);

            on('click', function (evt) {
                formValidation.getApi(form).then((formApi) => {
                    let formInstance = formApi.getFormInstance();
                    formInstance.validate().then((state) => {
                        if (state === 'Valid' ) {
                            validatePassword(evt, true);
                        }else{
                            validatePassword(evt, false);
                        }
                    });
                });
                scrollTop(form);
            }, submitButton)
        }

        if(validatePasswordBtn){
            on('click', function (evt){
                validatePassword(evt, false);
            }, validatePasswordBtn);
        }


        on("input", (evt) => {
            isSame = password.value === repeatPassword.value;
            validatePassword(evt, false);
        }, repeatPassword);


        on("input", (evt) => {
            setBooleans();
            if(repeatPassword.value){
                isSame = password.value === repeatPassword.value;
                validatePassword(evt, false);
            }
        }, password);

        function setBooleans(){
            let value = password.value;
            isSame = password.value === repeatPassword.value;
            if (value.length > 0) {
                hasValue = true;
            }


            if(hasEightCharacters(value)){
                lengBoolean = true;
            } else if(!hasEightCharacters(value)){
                lengBoolean = false;
            }

            if(hasTwoLowercaseLetters(value)){
                smallLetterBoolean = true;
            } else if(!hasTwoLowercaseLetters(value)){
                smallLetterBoolean = false;
            }

            if(hasNumber(value)){
                numBoolean = true;
            }else if(!hasNumber(value)){
                numBoolean = false;
            }

            if (lengBoolean == true && smallLetterBoolean == true && numBoolean == true) {
                requirements.forEach((element) => {
                    element.classList.add("text-success");
                });
                isValid = true;
            } else {
                isValid = false;

                if (lengBoolean == false) {
                    leng.classList.remove("text-success");
                } else {
                    leng.classList.add("text-success");
                }


                if (smallLetterBoolean == false) {
                    smallLetter.classList.remove("text-success");
                } else {
                    smallLetter.classList.add("text-success");
                }

                if (numBoolean == false) {
                    num.classList.remove("text-success");
                } else {
                    num.classList.add("text-success");
                }
            }
        }


        function validatePassword(evt, submitForm){
            if(!isValid  || !isSame || !hasValue){
                if(!hasValue){
                    repeatPassword.classList.add("is-invalid");
                    repeatPassword.classList.remove("is-valid");
                    password.classList.add("is-invalid");
                    password.classList.remove("is-valid");
                    let errorMessageRequired = translate('registration.not valid');
                    errors.innerHTML = errorMessageRequired;
                }
                else if(!isValid ){
                    repeatPassword.classList.add("is-invalid");
                    repeatPassword.classList.remove("is-valid");
                    password.classList.add("is-invalid");
                    password.classList.remove("is-valid");
                    let errorMessageNotIdentical = translate('registration.invalid-password');
                    errors.innerHTML = errorMessageNotIdentical;
                }
                else if(!isSame){
                    repeatPassword.classList.add("is-invalid");
                    repeatPassword.classList.remove("is-valid");
                    password.classList.add("is-invalid");
                    password.classList.remove("is-valid");
                    let errorMessageNotIdentical = translate('registration.mismatching-password');
                    errors.innerHTML = errorMessageNotIdentical;
                }
                else{
                    repeatPassword.classList.remove("is-invalid");
                    repeatPassword.classList.add("is-valid");
                    password.classList.remove("is-invalid");
                    password.classList.add("is-valid");
                    errors.innerHTML = "";
                }
                if(validatePasswordSubmitBtn){
                    validatePasswordSubmitBtn.setAttribute('disabled', true);
                }
                evt.preventDefault();
            }else{
                repeatPassword.classList.remove("is-invalid");
                repeatPassword.classList.add("is-valid");
                password.classList.remove("is-invalid");
                password.classList.add("is-valid");
                errors.innerHTML = "";
                if(validatePasswordBtn){
                    validatePasswordBtn.removeAttribute('disabled');
                }
                if(validatePasswordSubmitBtn){
                    validatePasswordSubmitBtn.removeAttribute('disabled');
                }
                if(submitForm){
                    let dataAction = form.getAttribute('data-action');
                    form.setAttribute('action', dataAction);
                    form.submit();
                }
            }
        }
    });
}

function hasEightCharacters(input) {
    const matches = input.match(/[a-zA-Z]/g);
    return matches && matches.length >= 8;
}

function hasTwoLowercaseLetters(input) {
    const matches = input.match(/[a-z]/g);
    return matches && matches.length >= 2;
}

//check if input has at least 1 number
function hasNumber(input) {
    const matches = input.match(/[0-9]/g);
    return matches && matches.length >= 1;
}

